module.exports = __webpack_public_path__ + "static/media/NEGATIF.17515b27.svg";